import * as React from "react";
import CrossProviderModel from "./CrossProviderModel";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelDescription from "../../../components/model/ModelDescription";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import Disclaimer from "../../../components/model/Disclaimer";

const CrossProvider = () => {
    return (
        <ModelContainer>
            <PageTitle/>
            <div>
                <ModelTitle>Cross Provider</ModelTitle>
                <ModelInfo model={GAEventModels.CROSS_PROVIDER}/>
                <ModelDescription>Combine the output of multiple models to obtain powerful results.</ModelDescription>
                <CrossProviderModel/>
                <Disclaimer/>
            </div>
        </ModelContainer>
    );
};

export default CrossProvider;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/index.tsx